import React, { useContext } from 'react';
import styled from 'styled-components';
import { Tooltip } from '@ubeya/shared-web/components';
import useFormattingMap from '@ubeya/shared-web/hooks/useFormattingMap';
import ConfigContext from '@ubeya/shared-web/contexts/ConfigContext';
import { ReactComponent as BaseErrorIcon } from '@ubeya/shared-web/assets/error.svg';

const ErrorIcon = styled(BaseErrorIcon)`
  width: 16px;
  height: 16px;
  flex-shrink: 0;
  cursor: help;
`;

const TooltipBody = styled.div`
  text-align: left;
  white-space: nowrap;
`;

const TooltipTitle = styled.div`
  font-weight: 500;
  margin-bottom: 4px;
`;

const SOURCE_TRANSLATION_KEYS = {
  account: 'minimumWageAccountSource',
  branch: 'minimumWageBranchSource'
};

const MinimumWageIndicator = ({ minimumWageWarning }) => {
  const { t } = useContext(ConfigContext);
  const formattingMap = useFormattingMap();
  const { minimumWage, source, workedHours, minimumTotalPay } = minimumWageWarning || {};
  const hasMinimumTotalPay = workedHours !== undefined && minimumTotalPay !== undefined;
  const sourceTranslationKey = SOURCE_TRANSLATION_KEYS[source];

  return (
    <Tooltip
      body={
        <TooltipBody>
          <TooltipTitle>{t('minimumWageNotMet')}</TooltipTitle>
          <div>{t('minimumWageRate', { value: formattingMap.currency(minimumWage) })}</div>
          {sourceTranslationKey && <div>{t(sourceTranslationKey)}</div>}
          {hasMinimumTotalPay && (
            <div>
              {t('minimumWageMinimumTotalPay', {
                hours: workedHours,
                value: formattingMap.currency(minimumTotalPay)
              })}
            </div>
          )}
        </TooltipBody>
      }>
      <ErrorIcon />
    </Tooltip>
  );
};

export default MinimumWageIndicator;
